import { Divider as DividerComponent, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillLine = styled.div`
  padding-top: ${Spacing.S8};
  padding-bottom: ${Spacing.S4};
`

export const BillLineTitleWrapper = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
`

export const Divider = styled(DividerComponent)`
  margin-top: ${Spacing.S12};
`
